export default __webpack_public_path__ + "img/sidebars-1-f58e217a.png";